import { Col, GRID } from '../../components/custom';

export default function MRT()
{
    return (
        <Col id='MRT' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Message Recall & Testing in Pharma</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To assess the <strong>effectiveness of promotional messages</strong> used in pharmaceutical marketing — specifically measuring <strong>unaided and aided message recall, resonance, and persuasive power</strong> among target HCPs.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Data Source</span>
                        <span className='descsmall'>Survey of 200 healthcare professionals exposed to promotional content (e.g., digital campaigns, rep detailing, journal ads).</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Key Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Unaided Message Recall:</strong> Open-ended mention of key themes</li> 
                            <li className='descsmall'><strong>Aided Recall:</strong> Recognition of key brand messages from a list</li> 
                            <li className='descsmall'><strong>Resonance Score:</strong> Likert scale (1-5) rating for how well message aligns with professional values or patient needs</li> 
                            <li className='descsmall'><strong>Persuasiveness:</strong> Likert scale (1-5) indicating intention to act (e.g., trial/prescribe)</li> 
                            <li className='descsmall'><strong>Other Variables:</strong> Specialty, rep visit, region, brand familiarity</li> 
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Analytical Techniques</span>
                        <ul>
                            <li className='descsmall'><strong>Recall Analysis:</strong> Open-ended mention of key themes</li> 
                            <li className='descsmall'><strong>Message Resonance Scoring:</strong> Recognition of key brand messages from a list</li> 
                            <li className='descsmall'>
                                <strong>Statistical Tests:</strong>
                                <ul>
                                    <li className='descsmall'><strong>ANOVA:</strong> Differences in resonance across messages</li>
                                    <li className='descsmall'><strong>Chi-square Test:</strong> Association between recall and rep visit</li>
                                    <li className='descsmall'><strong>Logistic Regression:</strong> Predict likelihood to prescribe based on resonance</li>
                                </ul>
                            </li> 
                        </ul>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Sample Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Message Performance Summary</span>
                        <GRID className='_5x4'>
                            <span className='descsmall bold'>Message</span>
                            <span className='descsmall bold'>Unaided Recall</span>
                            <span className='descsmall bold'>Aided Recall</span>
                            <span className='descsmall bold'>Resonance Score</span>
                            <span className='descsmall bold'>Persuassion Score</span>
                            <span className='descsmall bold left'>Efficacy</span>
                            <span className='descsmall'>42%</span>
                            <span className='descsmall'>78%</span>
                            <span className='descsmall'>4.2</span>
                            <span className='descsmall'>4.0</span>
                            <span className='descsmall bold left'>Safety</span>
                            <span className='descsmall'>26%</span>
                            <span className='descsmall'>60%</span>
                            <span className='descsmall'>3.9</span>
                            <span className='descsmall'>3.7</span>
                            <span className='descsmall bold left'>Simplicity</span>
                            <span className='descsmall'>18%</span>
                            <span className='descsmall'>52%</span>
                            <span className='descsmall'>3.5</span>
                            <span className='descsmall'>3.4</span>
                        </GRID>
                        <ul>
                            <li className='descsmall'><strong>Efficacy message</strong> performs best across all metrics.</li>
                            <li className='descsmall'><strong>Simplicity message</strong> underperforms, especially in unaided recall and resonance.</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Statistical Insights</span>
                        <ul>
                            <li className='descsmall'><strong>ANOVA</strong> showed significant differences in resonance between messages (p {'<'} 0.01)</li>
                            <li className='descsmall'><strong>Chi-square:</strong> Physicians who had a <strong>rep visit in past 3 months</strong> were significantly more likely to recall <strong>efficacy messaging</strong> <br/> unaided (p {'<'} 0.05)</li>
                            <li className='descsmall'><strong>Logistic Regression:</strong> A 1-point increase in <strong>resonance score</strong> increased likelihood to <strong>prescribe by 1.8x (OR = 1.8, p {'<'} 0.01)</strong></li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Segmentation Insights</span>
                        <GRID className='_2x4'>
                            <span className='descsmall bold'>Segment</span>
                            <span className='descsmall bold'>Characteristics</span>
                            <span className='descsmall bold'>Segment 1</span>
                            <span className='descsmall'>High recall, high resonance → Message-aligned prescribers</span>
                            <span className='descsmall bold'>Segment 2</span>
                            <span className='descsmall'>High recognition, low resonance → Aware but unconvinced</span>
                            <span className='descsmall bold'>Segment 3</span>
                            <span className='descsmall'>Low recall and resonance → Message-unaware or disengaged</span>
                        </GRID>
                    </Col>
                </Col>
            </Col>
            <Col className='section recommendations'>
                <span className='title'>Strategic Recommendations</span>
                <ul>
                    <li className='descsmall'><strong>Double down</strong> on high-performing messages (e.g., Efficacy) for reinforcement in both digital and face-to-face channels</li>
                    <li className='descsmall'><strong>Rework underperforming themes</strong> (e.g., Simplicity) to better align with clinical priorities</li>
                    <li className='descsmall'><strong>Target rep efforts</strong> toward Segment 2 (aware but unconvinced) with deeper clinical content or real-world evidence</li>
                    <li className='descsmall'><strong>Track recall/resonance over time</strong> to optimize messaging effectiveness across campaigns</li>
                </ul>
            </Col>
        </Col>
    )
}